import { render, staticRenderFns } from "./serve.vue?vue&type=template&id=f29ad97e&scoped=true&"
var script = {}
import style0 from "./serve.vue?vue&type=style&index=0&id=f29ad97e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29ad97e",
  null
  
)

export default component.exports